import React from 'react';

const education = [
  {
    id: 'education-centennial',
    institution: 'Centennial College',
    degree: 'Graduate Certificate in Software Engineering',
    location: 'Toronto, ON, Canada',
    period: '2024 – Present',
    active: true,
    focus: 'Software engineering foundations, systems thinking, and production-oriented development workflows.',
  },
  {
    id: 'education-evad',
    institution: 'EVAD Málaga',
    degree: 'Associate Degree in Game Development',
    location: 'Málaga, Spain',
    period: '2022 – 2024',
    active: false,
    focus: 'Graphics programming, engine architecture, real-time rendering, and technical art pipeline fundamentals.',
  },
];

const langs = [
  { name: 'English', level: 'Professional' },
  { name: 'Spanish', level: 'Native' },
];

const Education: React.FC = () => (
  <section id="education" data-topic="neutral">
    <div className="content" style={{ paddingBottom: '3rem' }}>

      <h2 className="section-heading">Education</h2>

      {education.map((edu, i) => (
        <div key={i} id={edu.id} className="entry section-anchor-target education-entry">
          <div className="entry-header">
            <div>
              <span className="entry-title">
                {edu.institution}
                {edu.active && <span className="badge-live" style={{ marginLeft: '8px' }}>Active</span>}
              </span>
              <div className="entry-sub">{edu.degree}</div>
              <div className="entry-meta">{edu.location}</div>
            </div>
            <div className="entry-meta">{edu.period}</div>
          </div>
          <div className="entry-sub" style={{ marginBottom: 0 }}>{edu.focus}</div>
        </div>
      ))}

      <hr className="hr" style={{ margin: '1.5rem 0' }} />

      <div style={{ fontSize: '11px', color: 'var(--fg-3)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '0.75rem' }}>
        Language Proficiency
      </div>
      <div style={{ display: 'flex', gap: '2rem' }}>
        {langs.map((l, i) => (
          <div key={i} style={{ fontSize: '13px' }}>
            <span style={{ color: 'var(--fg)', fontWeight: 500 }}>{l.name}</span>
            <span style={{ color: 'var(--fg-3)', marginLeft: '6px' }}>{l.level}</span>
          </div>
        ))}
      </div>

    </div>
  </section>
);

export default Education;
